import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isActiveNavItem, isActiveNavFlyout } from '../../helpers/navigationHelpers';
import NavigationFlyout from '../components/NavigationFlyout/NavigationFlyout';
import Link from '../../../shared/components/Link/Link';
import createUniqueId from '../../../shared/helpers/createUniqueId';


const NavigationMain = function NavigationMainComponent({ categories }) {
  const leftAlignNav = categories.length < 4;
  const navCategories = classNames({
    'navigation-main__categories': true,
    'navigation-main__categories--left-align': leftAlignNav,
  });

  return (
    <nav className="navigation-main" role="navigation" aria-label="Main">
      <div className="se-container">
        <ul className={navCategories}>
          {categories.map((category) => {
            const navCategory = classNames({
              'navigation-main__category': true,
              'navigation-main__category--left-align': leftAlignNav,
              'navigation-main__category--active': isActiveNavItem(category.url),
              'navigation-main__category--flyout--active': isActiveNavFlyout(category),
            });

            const flyoutId = createUniqueId('navigation_flyout_', category.id);

            if (category.subGroups && category.subGroups.length) {
              return (
                <li
                  key={category.id}
                  className={`${navCategory} navigation-main__category--flyout`}
                >
                  <NavigationFlyout
                    id={flyoutId}
                    styleFlag="nav-flyout"
                    navItem={category}
                  />
                  <span className="navigation-main__category-accent" />
                </li>
              );
            }

            return (
              <li
                key={category.id}
                className={navCategory}
              >
                <Link
                  className="navigation-main__link"
                  href={category.url}
                  external={category.isExternal}
                >
                  {category.name}
                </Link>
                <span className="navigation-main__category-accent" />
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

NavigationMain.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default NavigationMain;
